//lccccccc
// import {
//   Ajax,
//   findMax
// } from "../PC/common_product_list_pro";
// ajax请求
const Ajax = (args, datas, viewmodel) => {
  var proxy = cb.rest.DynamicProxy.create({
    ensure: {
      url: args.cSvcUrl,
      method: args.cHttpMethod
    }
  });
  // 提交到后端的数据
  var params = {
    billnum: "aa_userauthlist",
    action: args.cAction,
    data: JSON.stringify(datas)
  }
  proxy.ensure(params, function(err, result) {
    if (err) {
      cb.utils.alert(err.message, 'error');
      return;
    }
    let { count, failCount, messages, sucessCount } = result;
    if (sucessCount) {
      cb.utils.alert(args.cShowCaption + '授权成功' + sucessCount + '条', 'success');
    }
    if (failCount !== undefined) {
      messages.forEach(v => {
        cb.utils.alert(v, 'warning');
      })
      viewmodel.execute('back');
      return false
    }
    cb.utils.alert("操作成功", 'success');
    viewmodel.execute('back');
  });
}

cb.define(function () {
  var AA_aa_userauthlist_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {

      viewmodel.getGridModel().on('beforeLoad', function (data) {
        if (data.condition) {
          //管理员不能被从列表操作
          data.condition['isExtend'] = true;
          data.condition['simpleVOs'] = [];
          var simpleVOs = data.condition.simpleVOs;
          var defwhere = {};
          defwhere['field'] = 'userType';
          defwhere['value1'] = 0;
          defwhere['op'] = 'neq';
          simpleVOs.push(defwhere);
          defwhere = {};
          defwhere['field'] = 'id';
          defwhere['value1'] = cb.rest.AppContext.user.id;
          defwhere['op'] = 'neq';
          simpleVOs.push(defwhere);
          defwhere = {};
          defwhere['field'] = 'userType';
          defwhere['value1'] = -1;
          defwhere['op'] = 'neq';
          simpleVOs.push(defwhere);
        }
      });

      viewmodel.on('beforeAdd', function (args) {
        let selectedRows = viewmodel.getGridModel().getSelectedRows();
        if (!selectedRows.length) {
          cb.utils.alert('请选择一个用户', 'error')
          return false
        }
        if (selectedRows.length !== 1) {
          cb.utils.alert('只能选择一个用户授权', 'error')
          return false
        }
        viewmodel.communication({
          payload: {
            title: '编辑业务权限设置',
            type: 'platform',
            url: 'BusinessJurisdiction',
            checkReturn: false,
            data: {
              url: selectedRows[0].id,
              mode: 'edit',
              readOnly: false
            }
          }
        });
        return false;
      });

      window.addEventListener("message", (args) => {
        let {data} = args;
        if (data.random && data.random.includes('businessJurisdiction') && data.key === "crossdomainpush" && data.msg) {
          if (data.msg.type === 'success') {
            cb.utils.alert('保存成功', 'success');
          } else {
            cb.utils.alert("保存失败", 'error');
          }
        }
      }, false);

      viewmodel.on('beforeEdit', function (args) {
        viewmodel.communication({
          payload: {
            title: '编辑业务权限设置',
            type: 'platform',
            url: 'BusinessJurisdiction',
            checkReturn: false,
            data: {
              url: args.carry.id,
              mode: 'edit',
              readOnly: false
            }
          }
        });
        return false;
      });

      viewmodel.getGridModel().on('beforeDblClick', (args) => {
        viewmodel.communication({
          payload: {
            title: '编辑业务权限设置',
            type: 'platform',
            url: 'BusinessJurisdiction',
            checkReturn: false,
            data: {
              url: args.id,
              mode: 'edit',
              readOnly: true
            }
          }
        });
        return false;
      })


      //lcccc
      let gridModel = viewmodel.getGridModel();
      // 门店相关
      //门店参照字段所在的隐藏的viewmodel 门店参照类型
      var storeReferModel = new cb.models.ReferModel({ cRefType: 'retail.aa_store', multiple: 'true' });
      //门店参照字段 itembase
      viewmodel.addProperty('storeRef', storeReferModel);
      storeReferModel.setVisible(false);
      //门店选项action
      viewmodel.on('openStoreRef', function (args) {
        storeReferModel.setCache('args', args);
        storeReferModel.setCondition({});
        storeReferModel.browse(true);
      });
      //新增门店之前判断是否选择用户
      storeReferModel.on('beforeBrowse', function (data) {
        var selectedRows = gridModel.getSelectedRows();
        if (selectedRows == undefined || selectedRows.length == 0) {
          cb.utils.alert('至少选择一个用户！', 'warning');
          return false;
        }
      });
      //门店 lccccc
      storeReferModel.on('afterValueChange', function (args) {
        Object.assign(args, this.getCache('args'));
        if (args && !args.value) {
          cb.utils.alert('未选择门店！', 'warning');
          return false
        }
        if (args.cAction == 'openStoreRef') {
        }
        //选中的要给其新增门店或仓库的用户 数组！！！
        var selectedRows = gridModel.getSelectedRows();
        //选中的要新增的门店 数组！！！
        let storeList = args.value;
        var storeData = [];
        for (let i = 0; i < selectedRows.length; i++) {
          storeData.push({
            "userId": selectedRows[i]["id"],
            "storeList":storeList
          });
        }
        Ajax(args, storeData, viewmodel)
      })

      // 仓库相关
      //仓库参照字段所在的隐藏的viewmodel 仓库参照类型
      var warehouseReferModel = new cb.models.ReferModel({ cRefType: 'retail.aa_warehouse', multiple: 'true' });
      //仓库参照字段 itembase
      viewmodel.addProperty('warehouseRef', warehouseReferModel);
      warehouseReferModel.setVisible(false);
      //仓库选项action
      viewmodel.on('openWarehouseRef', function (args) {
        warehouseReferModel.setCache('args', args);
        warehouseReferModel.setCondition({});
        warehouseReferModel.browse(true);
      });
      //新增仓库之前判断是否选择用户
      warehouseReferModel.on('beforeBrowse', function (data) {
        var selectedRows = gridModel.getSelectedRows();
        if (selectedRows == undefined || selectedRows.length == 0) {
          cb.utils.alert('至少选择一个用户！', 'warning');
          return false;
        }
      });
      //仓库 lccccc
      warehouseReferModel.on('afterValueChange', function (args) {
        Object.assign(args, this.getCache('args'));
        if (args && !args.value) {
          cb.utils.alert('未选择仓库！', 'warning');
          return false
        }
        if (args.cAction == 'openWarehouseRef') {
        }
        //选中的要给其新增门店或仓库的用户 数组！！！
        var selectedRows = gridModel.getSelectedRows();
        //选中的要新增的仓库 数组！！！
        let WarehouseList = args.value;
        var WarehouseData = [];
        for (let i = 0; i < selectedRows.length; i++) {
          WarehouseData.push({
            "userId": selectedRows[i]["id"],
            "WarehouseList":WarehouseList
          });
        }
        Ajax(args, WarehouseData, viewmodel)
      })
    }
  };
  try {module.exports = AA_aa_userauthlist_VM_Extend; } catch (error) {}
  return AA_aa_userauthlist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_userauthlist_VM.Extend.js